import Reveal from '@/components/base/Reveal';
import { trendingStories } from '@/mocks/tracking';

const pillMap = {
  primary: 'bg-primary-100 text-primary-800 border-primary-200',
  accent: 'bg-accent-100 text-accent-800 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-800 border-secondary-200',
} as const;

export default function Watch() {
  return (
    <section id="watch" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <Reveal>
        <div className="flex flex-col gap-4 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">正在跟踪 · 进行中</p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              在线黑料正在追的事件
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              聚焦后续进展与当事人回应，跟踪报道持续更新，关注反转可能。任何一次新增证据、声明或录音，都会第一时间同步到这里。
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-2 rounded-lg border border-background-200 bg-background-100 px-4 py-2.5">
            <span className="live-dot h-2 w-2 rounded-full bg-accent-500" />
            <span className="font-label text-xs font-medium text-foreground-700">最近更新 2 分钟前</span>
          </div>
        </div>
      </Reveal>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {trendingStories.map((story, idx) => (
          <Reveal key={story.id} delay={(idx % 3) * 90}>
            <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300">
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1.5 font-label text-xs font-medium text-foreground-500">
                  <i className="ri-fire-fill text-accent-500" />
                  {story.heat}
                </span>
                <span className="font-label text-[11px] text-foreground-400">No.{String(idx + 1).padStart(2, '0')}</span>
              </div>

              <span className={`mt-4 inline-flex w-fit items-center rounded-full border px-2.5 py-1 font-label text-[11px] font-medium ${pillMap[story.tone]}`}>
                {story.status}
              </span>

              <h3 className="mt-3 font-heading text-base font-bold leading-relaxed text-foreground-950 group-hover:text-foreground-800">
                {story.title}
              </h3>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{story.digest}</p>

              <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                <span className="whitespace-nowrap">{story.updated}</span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-chat-3-line" /> {story.talks} 讨论
                </span>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}